module.exports = __webpack_public_path__ + "img/244766b.jpg";